// extracted by mini-css-extract-plugin
export var activityContainer = "_fc-0";
export var typingIndicatorContainer = "_fc-1";
export var typingIndicatorDot = "_fc-2";
export var wave = "_fc-3";